<template>
  <div class="heatmap-report">
    <div class="fixed_content">
      <h2 hidden>{{ $t('cta.title') }}</h2>
      <heatmap
        mode="cta"
        :aid="aid"
        :activeSelector="activeSelector"
        :userActionData="userActionData"
        :isDownloading="isDownloading"
        :heatmapType="heatmapType"
        :hourData="hourData"
        :isReportClick="isReportClick"
        @onTimeSeries="onTimeSeries"
        @onDownloading="onDownloading"
        @onHeatmapLoadStart="onHeatmapLoadStart"
        @onHeatmapLoadEnd="onHeatmapLoadEnd"
        @onHeatmapData="onHeatmapData"
        @onCtaReportData="onCtaReportData"
        @onCtaDataChange="onCtaDataChange"
        @setHeatmapType="setHeatmapType"
        @onActiveSelectorChange="activeSelector = $event"
        @onUserActionDataChange="userActionData = $event"/>
    </div>
    <scroll-content class="scroll_content" ref="container">
      <div class="reporting-heatmap-analysis">
        <cta-analytics v-if="ctaData.coords && ctaReportData"
          :ctaData="ctaData"
          :reportData="ctaReportData"
          :reportName="reportName"
          :isAMP="applyData.bAMP"
          :timeSeries="timeSeries"
          @onCtaDataChange="onCtaDataChange"
          @onHourData="onHourData"/>

        <report-stream v-if="reportName === 'stream'"
          :isCta=true
          :isAMP="applyData.bAMP"
          :isLoading="isLoading"
          :reportName="reportName"
          :reportData="reportData"
          :activeSelector="activeSelector"
          :userActionData="userActionData"
          @onConversionChange = "conversion = $event"
          @onActivityStatisticsChange = "activityStatistics = $event"
          @onActiveSelectorChange="activeSelector = $event"
          @onUserActionDataChange="userActionData = $event"/>
        <cta-rank-list v-if="!ctaData.coords && reportData"
          :reportData.sync="reportData"
          :hasTopData.sync="hasTopData"
          :activeSelector="activeSelector"
          :ctaData="ctaData"
          :isLoading="isLoading"
          :timeSeries="timeSeries"
          @onActiveSelectorChange="activeSelector = $event"
          @onCtaDataChange="onCtaDataChange"
          @onHourData="onHourData"/>

        <back-to-top v-if="!isLoading && hasTopData" refName="container"/>
      </div>
      <div class="scroll_content-loading">
        <ui-loading-circle v-if="isLoading" :applyBackground="true"/>
      </div>
    </scroll-content>
    <download-error :isDownloading="isDownloading"
                    @onDownloading="onDownloading"></download-error>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Heatmap from '@/components/heatmap'
import DownloadError from '@/components/heatmap/HeatmapDownloadError'
import CtaRankList from '@/components/report-cta/CtaRankList'
import CtaAnalytics from '@/components/report-cta/CtaAnalytics'
import ReportStream from '@/components/reporting-heatmaps/ReportStream'
import ScrollContent from '@/components/ui/ScrollContent'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import BackToTop from '@/components/ui/BackToTop'

export default {
  name: 'CtaReport',
  components: {
    Heatmap,
    CtaRankList,
    CtaAnalytics,
    ReportStream,
    ScrollContent,
    UiLoadingCircle,
    BackToTop,
    DownloadError
  },
  props: [
    'cacheManager'
  ],
  data () {
    return {
      reportName: null,
      reportData: null,
      hasTopData: null,
      ctaReportData: null,
      activeSelector: null,
      userActionData: null,
      isLoading: true,
      isDownloading: false,
      heatmapType: 0,
      timeSeries: null,
      hourData: null,
      isReportClick: false
    }
  },
  computed: {
    ...mapState([
      'ctaData',
      'applyData'
    ]),
    aid () {
      return this.$route.params.aid
    }
  },
  watch: {
    aid (value) {
      this.reload()
    }
  },
  created () {

  },
  destroyed () {
    this.setCtaData({})
  },
  methods: {
    ...mapMutations([
      'setCtaData'
    ]),
    setHeatmapType (value) {
      this.$emit('setHeatmapType', value)
      this.heatmapType = value
    },
    onHeatmapData (key, value) {
      this.reportName = key
      this.reportData = value
      if (key !== 'stream') {
        this.activityStatistics = 'median'
        this.conversion = null
      }
    },
    onCtaReportData (value) {
      this.ctaReportData = value
    },
    reload () {
    },
    onHeatmapLoadStart (type) {
      this.isLoading = true
    },
    onHeatmapLoadEnd (type) {
      this.isLoading = false
    },
    onCtaDataChange (value) {
      this.isLoading = true
      this.setCtaData(value)
      this.isReportClick = true
    },
    onDownloading (value) {
      this.isDownloading = value
    },
    backToTop () {
      this.$refs.reportComponent.$el.scrollIntoView(true)
    },
    onTimeSeries (value) {
      this.timeSeries = value
    },
    onHourData (value) {
      this.hourData = String(value)
    }
  }
}
</script>

<style lang="scss">
.reporting-heatmap-analysis {
  .content-box {
    width: 100%;
    border-radius: 14px;
    background-color: #ffffff;
    padding: 25px;
    box-sizing: border-box;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
  }
  .no-data {
    position: relative;
    margin-top: 30px;
    height: 295px;
    border-radius: 14px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;

    p {
      font-size: 13px;
      line-height: 1.46;
      color: #2f2f2f;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .more-info--wrap {
    & > div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 830px;
      height: 574px;
      border-radius: 14px;
      box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
      background-color: #ffffff;
      color: #666666;
      padding: 30px 30px 35px;
      box-sizing: border-box;
      overflow: hidden;
    }

    table {
      width: 100%;
      text-align: center;
      table-layout: fixed;
      border-collapse: collapse;

      caption {
        text-align: left;
        font-size: 15px;
        font-weight: 600;
        color: #2f2f2f;
        margin-bottom: 50px;

        span {
          font-size: 12px;
          color: $brandColor;
          margin-left: 20px;
          display: inline-block;
        }
      }

      thead tr{
        display: block;
        th {
          padding-bottom: 8px;
          border-bottom: 1px solid #bbbbbb;
          line-height: 1.23;
          font-size: 13px;
          color: #666666;
          font-weight: 500;

          span {
            display: inline-block;
            white-space: nowrap;
            width: 63px;
            text-align: right;
            position: relative;
            left: -10px;
          }
        }
      }

      tbody {
        display: block;
        overflow: auto;
        width: 100%;
        height: 420px;
        color: #2f2f2f;

        tr {
          font-weight: 500;
          height: 50px;
          border-bottom: 1px solid #ebebeb;
          box-sizing: border-box;
        }
      }
    }

    button {
      position: absolute;
      top: 0;
      right: 0;
      padding: 12px;
    }
  }
}
.heatmap-report {
  .btn__back-to-top {
    cursor: pointer;
    width: 100px;
    margin: 40px auto 0;
    text-align: center;

    p {
      margin-top: 8px;
    }
  }
}
.ie .reporting-heatmap-analysis {
  margin-bottom: 40px;
}

.popup__error {
  @include positionXYcenter;
  width: 430px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 50px 30px 25px;
  box-sizing: border-box;
  overflow: hidden;
  text-align: center;

  .title {
    margin-top: 15px;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    color: #444444;
  }

  .desc {
    margin-top: 15px;
    font-size: 14px;
    text-align: center;
    color: #2f2f2f;
  }

  .ui-btn {
    margin-top: 60px;
  }
}
</style>
